import React, { Component } from "react";
import FilterSelectAddFilterButton from "./FilterSelectAddFilterButton";
import { isPropsForLogicalOperator } from "./LogicalOperatorsOptions";

/**
 * Alows to set true/false for boolean operator
 */
class LogicalOperatorBooleanView extends Component {
  constructor(props) {
    super();
    this.state = isPropsForLogicalOperator(props)
      ? props.logicalOperator.value
      : {
          checkbox_true: false,
          checkbox_false: false,
        };
  }

  onChange = (id) => {
    this.setState({
      [id]: !this.state[id],
    });
  };

  /**
   * Set the value in the current Filter
   */
  onApplyFilter = () => {
    this.props.onApplyFilter && this.props.onApplyFilter(this.state);
  };

  render() {
    return (
      <>
        <div className="p-2 filter-container">
          <div className="form-row">
            <div className="col-4">
              <li className="filter-menu-opt-item">
                <input
                  name="checkbox_true"
                  id="checkbox_true"
                  type="checkbox"
                  checked={this.state.checkbox_true}
                  className="filter-menu-item-checbox"
                  onChange={() => this.onChange("checkbox_true")}
                />{" "}
                <label htmlFor="checkbox_true">True</label>
              </li>
            </div>
            <div className="col">
              <li className="filter-menu-opt-item">
                <input
                  type="checkbox"
                  name="checkbox_false"
                  id="checkbox_false"
                  checked={this.state.checkbox_false}
                  className="filter-menu-item-checbox"
                  onChange={() => this.onChange("checkbox_false")}
                />{" "}
                <label htmlFor="checkbox_false">False</label>
              </li>
            </div>
          </div>
        </div>
        <FilterSelectAddFilterButton
          disabled={!this.state.checkbox_true && !this.state.checkbox_false}
          onClick={this.onApplyFilter}
        />
      </>
    );
  }
}

export default LogicalOperatorBooleanView;
